import React from 'react';
import R from 'ramda';

import Card from 'js/components/card';

const Cards = ({jobList}) => {
    return R.pipe(
        R.splitEvery(2),
        R.map((jobRow) => (
            <div className="row" key={Math.random()}>
                <div className="gr-6@md">
                    <Card {...jobRow[0]} />
                </div>
                <div className="gr-6@md">
                    <Card {...jobRow[1]} />
                </div>
            </div>
        )),
        (content) => (<div>{content}</div>)
    )(jobList);
};

export default Cards;



// WEBPACK FOOTER //
// ./web/js/pages/jobs/cards.js